"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuditErrorCodeEnum = void 0;
var AuditErrorCodeEnum;
(function (AuditErrorCodeEnum) {
    AuditErrorCodeEnum["AUD001"] = "Audit Log Service returned an error.";
    AuditErrorCodeEnum["AUD002"] = "AuditView Database connection might be temporarily unavailable or down.";
    AuditErrorCodeEnum["AUD003"] = "Unable to get audit data from Audit database.";
    AuditErrorCodeEnum["AUD004"] = "Oracle Database generic error.";
    AuditErrorCodeEnum["AUD005"] = "No more audit records to retrieve.";
    AuditErrorCodeEnum["AUD006"] = "Invalid request data.";
})(AuditErrorCodeEnum || (exports.AuditErrorCodeEnum = AuditErrorCodeEnum = {}));
//# sourceMappingURL=audit-logs.enum.js.map